// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ErrorMsg_container__w5BaV {
  padding: 1rem;
  background-color: rgb(239, 63, 63);
  font-weight: 500;
  font-size: 18px;
  border-radius: 8px;
  max-width: 500px;
}

.ErrorMsg_container__w5BaV h4 {
  margin: 0;
}
`, "",{"version":3,"sources":["webpack://./src/components/errorMsg/ErrorMsg.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,SAAS;AACX","sourcesContent":[".container {\n  padding: 1rem;\n  background-color: rgb(239, 63, 63);\n  font-weight: 500;\n  font-size: 18px;\n  border-radius: 8px;\n  max-width: 500px;\n}\n\n.container h4 {\n  margin: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ErrorMsg_container__w5BaV`
};
export default ___CSS_LOADER_EXPORT___;
